function UserItemSkeleton({ num }) {
  return Array.from({ length: num }, (_, i) => (
    <div
      key={i}
      className="conv__list__inner__messagebox no-hover no-scroll flex flex-ai-c "
    >
      <div
        style={{ borderRadius: "50%" }}
        className="conv__list__inner__messagebox__avatar skeleton"
      ></div>

      <div className="conv__list__inner__messagebox__text">
        <div className="skeleton-text skeleton"></div>
        <div className="skeleton-text skeleton"></div>
        <div className="skeleton-text skeleton"></div>
      </div>
    </div>
  ));
}

export default UserItemSkeleton;
